import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
import { resetPassword } from 'services/users';
import getFormFieldVal from 'utils/getFormFieldVal';

class ResetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            password: '',
            errors: [],
            retype: '',
            invalidVerificationCode: 0,
            showReturnToLogin: 0,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.cognitoErrorList = {
            LimitExceededException: 'Attempt limit exceeded, please try after some time.',
            InvalidPasswordException: 'Password is invalid: Must contain letter, number, and symbol (for example: @, !, $, etc). Also the length should be minimum 8 characters.',
        };
        this.handleVerificationError = this.handleVerificationError.bind(this);;
    }

    handleVerificationError() {
        this.props.onVerificationError();
    }

    handleInputChange(event) {
        const fieldObj = getFormFieldVal(event);
        this.setState((prevState) => {
            if (prevState.errors.length) {
                const { errors } = prevState;
                const errorIndex = errors.indexOf(event.target.name);
                if (errorIndex >= 0) {
                    errors.splice(errorIndex, 1);
                }
                return { ...fieldObj, errors };
            }
            return { ...fieldObj };
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        const errorList = [];
        if (this.state.password === '') {
            errorList.push('password');
        }
        if (this.state.retype === '' || this.state.retype !== this.state.password) {
            errorList.push('retype');
        }

        this.setState({ errors: errorList });

        if (errorList.length > 0) return false;

        resetPassword(this.props.email, this.props.verificationCode, this.state.password)
            .then(() => {
                // Response handler
                this.props.history.push('/login');
            }).catch((err) => {
                // Error handler
                if (err.code === "CodeMismatchException") {
                    this.setState({ invalidVerificationCode: 1 });
                } else {
                    if (err.code === "LimitExceededException" || err.code === "ExpiredCodeException") {
                        this.setState({ showReturnToLogin: 1 })
                    }
                    this.setState({ cognitoError: this.cognitoErrorList.hasOwnProperty(err.code) ? this.cognitoErrorList[err.code] : err.message });
                }
                this.setState({ errors: ['password'] });
            });
    }

    /**
     * Searches the parameters to fill the form fields
     * @returns URL params
     */
    useQuery = () => new URLSearchParams(window.location.search);

    /**
     * Return true/false if the error exists on the error list
     * @param {String} key - error name
     */
    hasError(key) {
        return this.state.errors.indexOf(key) !== -1;
    }

    render() {
        return (
            <Form>
                <Form.Group controlId="password" className="control-group control-email">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                        className={
                            this.hasError('password')
                                ? 'form-control input-field input-password is-invalid'
                                : 'form-control input-field input-password'
                        }
                        name="password"
                        value={this.state.password}
                        onChange={this.handleInputChange}
                        type="password"
                        placeholder="Enter password"
                        required
                    />
                    {
                        this.state.invalidVerificationCode ?
                            (
                                <p className='invalid-feedback'>Invalid verification code. <a style={{color: '#dc3545'}} href="#" onClick={() => this.handleVerificationError()}>Click here to try again</a> </p>
                            ) :
                            (
                            <Form.Control.Feedback
                            type="invalid"
                            className={this.hasError('password') ? 'invalid-feedback' : 'hidden'}
                            >
                                {this.state.cognitoError}
                            </Form.Control.Feedback>
                            )

                    }
                </Form.Group>
                <Form.Group controlId="retype" className="control-group control-email">
                    <Form.Label>Retype Password</Form.Label>
                    <Form.Control
                        className={
                            this.hasError('retype')
                                ? 'form-control input-field input-password is-invalid'
                                : 'form-control input-field input-password'
                        }
                        name="retype"
                        value={this.state.retype}
                        onChange={this.handleInputChange}
                        type="password"
                        placeholder="Retype password"
                        required
                    />
                    <Form.Control.Feedback
                        type="invalid"
                        className={this.hasError('retype') ? 'invalid-feedback' : 'hidden'}
                    >
                        Password is invalid / do not match
                    </Form.Control.Feedback>
                </Form.Group>
                <Button className="login-button" onClick={this.handleSubmit} type="submit">
                    Reset Password
                </Button>
                {
                    this.state.showReturnToLogin ?
                    <div className="link-wrapper">
                    <Link
                        className="link"
                        to={{
                            pathname: '/login',
                            search: this.state.email ? `?email=${this.state.email}` : null
                        }}
                    >
                        Return to login
                    </Link>
                    </div> : ''
                }
            </Form>
        );
    }
}

export default withRouter(ResetPassword);
